import React, {useState, useEffect} from "react";

import { API_URL, GET_ADMIN_VAT_RATES, POST_ADMIN_VAT_RATES } from "../../../../constants";
import { GET_TOKEN } from "../../../../helpers";
import { LoadingSpinner } from "../../partials/LoadingSpinner";

export const CaTable = ({ selectedContinent }) => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitableData, setSubmitableData] = useState({});

  const CAVATcolumns = [
    {
      Header: "State",
      accessor: "country_id",
    },
    {
      Header: "Tax name",
      accessor: "tax_name",
    },
    {
      Header: "Federal",
      accessor: "federal",
    },
    {
      Header: "State/Province",
      accessor: "state_province",
    },
    {
      Header: "Combined %",
      accessor: "combined",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];

  let newData = {}

  useEffect(() => {
    setDataLoaded(false)
    let responseData = {}

    fetch(API_URL + GET_ADMIN_VAT_RATES + selectedContinent, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        return response.map((item) => {
            return responseData = {
              ...responseData,
              [item.id]: {
                country_id: item.country.name,
                tax_name: item.tax_name,
                federal: item.federal,
                state_province: item.state_province,
                combined: item.combined,
              }
            }
          })
      })
      .then(() => setSubmitableData(responseData))
      .then(() => setDataLoaded(true))
    
  }, []);

  // POST SAVE
  const saveChanges = (dataId) => {
    if (newData[dataId] !== undefined) {

      const submitBody = JSON.stringify({
        tax_name: newData[dataId].tax_name || submitableData[dataId].tax_name,
        federal: newData[dataId].federal || submitableData[dataId].federal,
        state_province: newData[dataId].state_province || submitableData[dataId].state_province,
      })
      
      console.log(submitBody)

  
      fetch(API_URL + POST_ADMIN_VAT_RATES + `${selectedContinent}/` + dataId , {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
        body: submitBody,
      })
      .then((response) => response.json())
      .then((response) => {
  
        response.error 
          ? console.error(response.error)
          : console.log('saved')
      })
      .catch(error => console.log(error));

    }
  }

  const GenerateTable = ({columns, data}) => {
    const generateHeader = () => {
      return <tr>
        {columns.map((item, i) => {
            return <th key={`ca_table_heading_${i}`}>
              {item.Header}
            </th>
        })}
      </tr>
    }

    const generateBody = () => {
      return Object.entries(data).map(
        ([dataId, dataObject], index) => {
          return <tr key={`ca_table_data_row_${index}_${dataId}`}>

              <td>{dataObject.country_id}</td>

              <td>
                <input 
                  type='text'
                  name='admin_tax_name'
                  className='default-input'
                  defaultValue={
                    (newData[dataId] !== undefined &&  newData[dataId]['tax_name'] !== undefined)
                      ? newData[dataId]['tax_name']
                      : submitableData[dataId]['tax_name']
                  }

                  onBlur={(e) => {
                    newData = {
                      ...newData,
                      [dataId]: {
                        ...newData[dataId],
                        tax_name: e.target.value
                      }
                    }
                  }}
                />
              </td>

              <td>
                <input 
                  type='number'
                  name='admin_federal'
                  className='default-input'

                  defaultValue={
                    (newData[dataId] !== undefined &&  newData[dataId]['federal'] !== undefined)
                      ? newData[dataId]['federal']
                      : submitableData[dataId]['federal']
                  }

                  onBlur={(e) => {
                    newData = {
                      ...newData,
                      [dataId]: {
                        ...newData[dataId],
                        federal: e.target.value
                      }
                    }
                  }}
                />
              </td>

              <td>
                <input 
                  type='number'
                  name='admin_state_province'
                  className='default-input'

                  defaultValue={
                    (newData[dataId] !== undefined &&  newData[dataId]['state_province'] !== undefined)
                      ? newData[dataId]['state_province']
                      : submitableData[dataId]['state_province']
                  }

                  onBlur={(e) => {
                    newData = {
                      ...newData,
                      [dataId]: {
                        ...newData[dataId],
                        state_province: e.target.value
                      }
                    }
                  }}
                />
              </td>

              <td>{dataObject.combined}</td>

              <td>
                <button 
                  className='default_button'
                  onClick={(e) => {
                    e.preventDefault()
                    saveChanges(dataId)
                  }}>
                  save
                </button>
              </td>
          </tr>
        }
      )
    }

    return <table className='default-table'>
      <tbody>
        {generateHeader()}
        {generateBody()}
      </tbody>
    </table>
  }

  return (
    <div className="CaTable">
      {!dataLoaded
        ? <LoadingSpinner />
        : <GenerateTable 
          columns={CAVATcolumns}
          data={submitableData}
        />
      }
    </div>
  );
};
